import React, { useContext, useEffect } from "react";
import { ProyectosContext } from "../../context/ProyectosContext";
import FechaEsperadaTerminacion from "../analiticas/FechaEsperadaTerminacion";
import AvanceFinanciero from "../analiticas/AvanceFinanciero";
import ProgramadoVsReal from "../analiticas/ProgramadoVsReal";

const Seccion = ({ titulo, children }) => (
  <div className="border rounded-3 p-2 mb-2 bg-white h-100">
    <h6 className="bold mb-2 px-2">{titulo}</h6>
    {children}
  </div>
);

// `indicadores` is the snapshot saved with the report; without it (preview)
// they are calculated as of `fecha`.
const ReporteIndicadores = ({
  idProyecto,
  fecha,
  indicadores,
  incluirFinanciero = true,
  incluirFechaTerminacion = true,
}) => {
  const { proyeccion, avanceFinanciero, getProyeccion, getAvanceFinanciero } =
    useContext(ProyectosContext);
  const guardado = indicadores && typeof indicadores === "object";

  useEffect(() => {
    if (!idProyecto || guardado) return;
    getProyeccion(idProyecto, fecha);
    if (incluirFinanciero) getAvanceFinanciero(idProyecto, fecha);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto, fecha, guardado, incluirFinanciero]);

  const getProyeccionReporte = () => {
    if (guardado) return indicadores.proyeccion ?? null;
    return proyeccion;
  };

  const getFinancieroReporte = () => {
    if (!incluirFinanciero) return null;
    if (guardado) return indicadores.financiero ?? null;
    return avanceFinanciero;
  };

  if (!idProyecto) return null;
  const datosProyeccion = getProyeccionReporte();
  const datosFinanciero = getFinancieroReporte();
  const tarjetas = [incluirFechaTerminacion, incluirFinanciero].filter(Boolean);
  const colClass = `col-12 col-md-${12 / Math.max(tarjetas.length, 1)} mb-2`;

  return (
    <div className="reporte-indicadores mt-3">
      <div className="row print-half-row">
        {incluirFechaTerminacion && (
          <div className={colClass}>
            <Seccion titulo="Fecha Esperada de Terminación">
              <FechaEsperadaTerminacion datos={datosProyeccion} />
            </Seccion>
          </div>
        )}
        {incluirFinanciero && (
          <div className={colClass}>
            <Seccion titulo="Avance Financiero">
              <AvanceFinanciero datos={datosFinanciero} />
            </Seccion>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12">
          <Seccion titulo="Programado vs Real">
            <ProgramadoVsReal
              proyeccion={datosProyeccion}
              financiero={datosFinanciero}
              height={230}
            />
          </Seccion>
        </div>
      </div>
    </div>
  );
};

export default ReporteIndicadores;
